module.exports = __webpack_public_path__ + "media/images/logo-bc3140c5d98bdcc77119935fe07baaf5.svg";